import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getRestaurantDistancePrice} from 'api/requests';
import {useAddressContext} from 'components/providers';
import {IAddress, IRestaurantDistancePriceResponse, QueryKeyEnum} from 'types';

interface IQuery {
  providerSlug: string | undefined;
  address?: IAddress;
}

export const useRestaurantDistancePrice = (
  {providerSlug}: IQuery,
  options?: UseQueryOptions<IRestaurantDistancePriceResponse>,
) => {
  const {selectedAddress} = useAddressContext();
  const {latitude, longitude} = selectedAddress?.address ?? ({} as IAddress);
  const enabled =
    !!latitude && !!longitude && !!providerSlug && providerSlug !== 'undefined' && providerSlug !== '[slug]';

  return useQuery<IRestaurantDistancePriceResponse>({
    queryKey: [QueryKeyEnum.DISTANCE_PRICE, providerSlug, selectedAddress?.address],
    queryFn: () =>
      getRestaurantDistancePrice(providerSlug, {
        latitude: +latitude,
        longitude: +longitude,
      }),
    ...options,
    enabled: enabled,
  });
};
